import ROUTES from 'routes';
import commonUrls from './urls';

export const clientdriverPermission = {
  urls: [...commonUrls],
  excludeUrls: [ROUTES.MY_REPORTS(), ROUTES.MY_TEAM()],
  hasNotification: false,
};
